import { useCallback, useState } from 'react';
import { BioSampleId } from '@csp/csp-common-hbs-model';
import { HbsSampleUpdatesContextState } from './HbsSampleUpdatesContextState';
import { HbsSampleUpdateSubscriber } from './HbsSampleUpdateSubscriber';

export const useHbsSampleUpdatesContextProvider = (): HbsSampleUpdatesContextState => {
  const [sampleUpdateSubscribers, setSampleUpdateSubscribers] = useState<HbsSampleUpdateSubscriber[]>([]);

  // TODO [Yoshi]: Add unregister subscriber?
  const registerSampleUpdateSubscriber = useCallback(
    (subscriber: HbsSampleUpdateSubscriber): void =>
      setSampleUpdateSubscribers(current => [
        ...current.filter(currentSubscriber => currentSubscriber.subscriberId !== subscriber.subscriberId),
        subscriber,
      ]),
    [setSampleUpdateSubscribers],
  );

  const registerSampleUpdate = useCallback(
    (sampleIdIn: BioSampleId): void => {
      sampleUpdateSubscribers.forEach(subscriber => {
        if (subscriber.sampleIds.includes(sampleIdIn)) {
          subscriber.onSampleUpdate(sampleIdIn);
        }
      });
    },
    [sampleUpdateSubscribers],
  );

  return {
    registerSampleUpdateSubscriber,
    registerSampleUpdate,
  };
};
